/* istanbul ignore file */
import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from '../template/impressionTrackingUrlDialogContent.pug';

export default class ImpressionTrackingUrlDialogContentView extends DeterministicView {
  initialize({
    i18n,
    isIASSectionVisible = true,
  }) {
    this.i18n = i18n;
    this.isIASSectionVisible = isIASSectionVisible;
    this.setState({
      error: '',
      rawInput: '',
    });
  }

  get template() {
    return template;
  }

  get events() {
    return !this.isIASSectionVisible ?
      {
        'focusout .impression-tracking-url-dialog-textarea textarea': (e) => {
          this.setState({
            rawInput: e.target.value,
          });
        },
        'change .impression-tracking-url-dialog-textarea textarea': () => {
          this.removeError();
        },
      } :
      {
        'focusout .ias-impression-tracking-url-dialog-textarea textarea': (e) => {
          this.setState({
            rawInput: e.target.value,
          });
        },
        'change .ias-impression-tracking-url-dialog-textarea textarea': () => {
          this.removeError();
        },
      };
  }

  setError() {
    this.setState({
      error: !this.isIASSectionVisible ?
        this.i18n.getString('ImpressionTrackingUrls_Dialog_Error_Message') :
        this.i18n.getString('IASImpressionTrackingUrls_Dialog_Error_Message'),
    });
  }

  removeError() {
    this.setState({
      error: '',
    });
  }
}
